import React from "react";
import Board from "./Board";
import Head from "./Header";

export default function GameBoardTemplate() {
  return (
    <>
      <Board />
    </>
  );
}
